import { render } from "./distributemodel.vue?vue&type=template&id=138260f0&scoped=true"
import script from "./distributemodel.vue?vue&type=script&lang=js"
export * from "./distributemodel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138260f0"]])

export default __exports__